import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const css = `
.verify-wrap { max-width:460px; margin:0 auto; padding:80px 20px; text-align:center; }
.verify-icon { font-size:64px; margin-bottom:20px; }
.verify-title { font-family:'Barlow Condensed',sans-serif; font-size:32px; font-weight:800; color:#F0F6FF; margin-bottom:10px; }
.verify-sub { color:#8899AA; font-size:15px; line-height:1.7; margin-bottom:28px; }
.verify-card { background:#0F1A2A; border:1px solid rgba(30,127,212,0.15); border-radius:14px; padding:32px; margin-bottom:24px; }
.btn-primary { display:inline-block; padding:12px 28px; background:#1E7FD4; color:#fff; border:none;
  border-radius:8px; font-size:14px; font-weight:700; cursor:pointer; text-decoration:none; transition:all 0.2s; }
.btn-primary:hover { background:#2E8FE4; text-decoration:none; }
.btn-ghost { display:inline-block; padding:12px 28px; background:transparent; color:#8899AA;
  border:1px solid rgba(255,255,255,0.1); border-radius:8px; font-size:14px; font-weight:600;
  cursor:pointer; text-decoration:none; transition:all 0.2s; margin-left:10px; }
.btn-ghost:hover { background:rgba(255,255,255,0.06); text-decoration:none; }
.spinner-wrap { display:flex; flex-direction:column; align-items:center; gap:16px; }
.spinner { width:40px; height:40px; border:3px solid rgba(30,127,212,0.2); border-top-color:#1E7FD4;
  border-radius:50%; animation:spin 0.8s linear infinite; }
@keyframes spin { to { transform:rotate(360deg); } }
.alert-success { background:rgba(109,190,69,0.1); border:1px solid rgba(109,190,69,0.3);
  color:#6DBE45; padding:12px 16px; border-radius:8px; font-size:14px; margin-bottom:16px; }
.alert-error { background:rgba(255,71,87,0.1); border:1px solid rgba(255,71,87,0.3);
  color:#FF6B7A; padding:12px 16px; border-radius:8px; font-size:14px; margin-bottom:16px; }
`;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error | already
  const [role, setRole] = useState('');
  const nav = useNavigate();
  const token = params.get('token');
  const type = params.get('type') || 'customer';

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    axios.post('/api/auth/verify-email', { token, type })
      .then(r => { setRole(r.data.role || type); setStatus('success'); })
      .catch(e => {
        const msg = e.response?.data?.error || '';
        setStatus(msg.includes('already') ? 'already' : 'error');
      });
  }, [token, type]);

  if (status === 'verifying') return (
    <><style>{css}</style>
    <div className="verify-wrap">
      <div className="spinner-wrap">
        <div className="spinner"/>
        <div style={{color:'#8899AA'}}>Verifying your email...</div>
      </div>
    </div></>
  );

  if (status === 'success') return (
    <><style>{css}</style>
    <div className="verify-wrap">
      <div className="verify-icon">✅</div>
      <div className="verify-title">Email Verified!</div>
      <div className="verify-card">
        <div className="alert-success">Your email address has been successfully verified.</div>
        {role === 'provider'
          ? <p style={{color:'#8899AA',margin:'0 0 20px',fontSize:14}}>Your application is now under review. We'll notify you once approved — usually within 1–2 business days.</p>
          : <p style={{color:'#8899AA',margin:'0 0 20px',fontSize:14}}>You can now sign in and start hiring verified data center professionals.</p>
        }
        <a href="/login" className="btn-primary">Sign In →</a>
      </div>
    </div></>
  );

  if (status === 'already') return (
    <><style>{css}</style>
    <div className="verify-wrap">
      <div className="verify-icon">👍</div>
      <div className="verify-title">Already Verified</div>
      <div className="verify-card">
        <p style={{color:'#8899AA',margin:'0 0 20px',fontSize:14}}>Your email is already verified. Just sign in!</p>
        <a href="/login" className="btn-primary">Sign In →</a>
      </div>
    </div></>
  );

  return (
    <><style>{css}</style>
    <div className="verify-wrap">
      <div className="verify-icon">❌</div>
      <div className="verify-title">Verification Failed</div>
      <div className="verify-card">
        <div className="alert-error">This verification link is invalid or has expired.</div>
        <p style={{color:'#8899AA',margin:'0 0 20px',fontSize:14}}>Request a new verification email by signing in.</p>
        <a href="/login" className="btn-primary">Go to Sign In</a>
        <a href="/" className="btn-ghost">Home</a>
      </div>
    </div></>
  );
}
